module.exports = __webpack_public_path__ + "img/ktb.65c7a704.png";